import { Provider } from '@repo/api-gw-sdk';

import { ConfirmationDialog } from '@/components/dialogs/confirmationDialog';

export function DeleteRestoreServerConfigDialog(props: {
  isOpen: boolean;
  name: string;
  provider: Provider;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { isOpen, onCancel, onConfirm, name, provider } = props;

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title='Delete customized settings'
      description={
        <>
          {'All customized settings for '}
          <b>{name}</b>
          {' will be removed. The restore server will use the default subnets '}
          {provider === Provider.Aws ? ' and security groups.' : '.'}
        </>
      }
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmSnackbarText={`Deleted customized ${provider === Provider.Aws ? 'VPC' : 'Network'} settings for ${name}.`}
      buttonTitle='Delete'
    />
  );
}
